export type MetricId =
  | 'sales'
  | 'payments'
  | 'proforma'
  | 'aviz'
  | 'expenses'
  | 'debitors'
  | 'suppliers'
  | 'stock'
  | 'newClients'
  | 'invoiceCount';

export type MetricCategory = 'flow-revenue' | 'flow-docs' | 'snapshot-stock' | 'activity-count';

export interface MetricDefinition {
  id: MetricId;
  label: string;
  description: string;
  /** `var(--sf-mc-…)`: valorile light/dark stau în vanzari.css (`.sf-monitor`), nu aici. Merge doar în CSS (style). */
  color: string;
  category: MetricCategory;
  unit: 'money' | 'count';
  isTimeSeries: boolean;
}

export const CATEGORY_LABELS: Record<MetricCategory, string> = {
  'flow-revenue': 'Bani (flow)',
  'flow-docs': 'Documente (flow)',
  'snapshot-stock': 'Snapshot (stock)',
  'activity-count': 'Activitate (count)',
};

export const METRICS: Record<MetricId, MetricDefinition> = {
  sales: {
    id: 'sales',
    label: 'Vânzări',
    description: 'Total facturat outgoing, agregat pe zi/săptămână',
    color: 'var(--sf-mc-sales)',
    category: 'flow-revenue',
    unit: 'money',
    isTimeSeries: true,
  },
  payments: {
    id: 'payments',
    label: 'Încasări',
    description: 'Plăți primite efectiv',
    color: 'var(--sf-mc-payments)',
    category: 'flow-revenue',
    unit: 'money',
    isTimeSeries: true,
  },
  proforma: {
    id: 'proforma',
    label: 'Proforme',
    description: 'Proforme emise',
    color: 'var(--sf-mc-proforma)',
    category: 'flow-docs',
    unit: 'money',
    isTimeSeries: true,
  },
  aviz: {
    id: 'aviz',
    label: 'Avize',
    description: 'Avize de însoțire',
    color: 'var(--sf-mc-aviz)',
    category: 'flow-docs',
    unit: 'money',
    isTimeSeries: true,
  },
  expenses: {
    id: 'expenses',
    label: 'Cheltuieli',
    description: 'Facturi incoming — de plătit sau plătite',
    color: 'var(--sf-mc-expenses)',
    category: 'flow-revenue',
    unit: 'money',
    isTimeSeries: true,
  },
  debitors: {
    id: 'debitors',
    label: 'Sold clienți',
    description: 'Total restant de încasat de la clienți (snapshot)',
    color: 'var(--sf-mc-debitors)',
    category: 'snapshot-stock',
    unit: 'money',
    isTimeSeries: false,
  },
  suppliers: {
    id: 'suppliers',
    label: 'Sold furnizori',
    description: 'Total de plătit către furnizori (snapshot)',
    color: 'var(--sf-mc-suppliers)',
    category: 'snapshot-stock',
    unit: 'money',
    isTimeSeries: false,
  },
  stock: {
    id: 'stock',
    label: 'Valoare stocuri',
    description: 'Valoare totală inventory la data curentă',
    color: 'var(--sf-mc-stock)',
    category: 'snapshot-stock',
    unit: 'money',
    isTimeSeries: false,
  },
  newClients: {
    id: 'newClients',
    label: 'Clienți noi',
    description: 'Clienți adăugați în perioadă',
    color: 'var(--sf-mc-new-clients)',
    category: 'activity-count',
    unit: 'count',
    isTimeSeries: true,
  },
  invoiceCount: {
    id: 'invoiceCount',
    label: 'Facturi emise',
    description: 'Număr facturi în perioadă',
    color: 'var(--sf-mc-invoice-count)',
    category: 'activity-count',
    unit: 'count',
    isTimeSeries: true,
  },
};

export const DEFAULT_ACTIVE: MetricId[] = ['sales', 'payments', 'proforma'];
export const MAX_ACTIVE = 4;
